import React from 'react'

export const UsersTable = () => {
    return (
        <div>UsersTable</div>
    )
}

export default UsersTable